import { INVALID_CREDENTIALS } from './errorMessages';

/**
 * Maps specific HTTP status codes to user-friendly error messages.
 * This object centralizes the relationship between HTTP status codes
 * and the corresponding error messages, ensuring consistency across the application.
 *
 * @constant {Object} STATUS_ERROR_MAP
 */
export const STATUS_ERROR_MAP = {
  400: INVALID_CREDENTIALS,
  401: INVALID_CREDENTIALS,
};
